var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"page-inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }